import AboutUs from '@/pages/AboutUs';
import AnnouncementNews from '@/pages/AnnouncementNews';
import AnnouncementNewsDetail from '@/pages/AnnouncementNews/detail';
import AnnouncementNewsMainPage from '@/pages/AnnouncementNews/mainPage';
import BlogPage from '@/pages/Blog';
import BlogDetail from '@/pages/Blog/BlogDetail';
import Catalog from '@/pages/Catalog';
import CatalogMainPage from '@/pages/Catalog/CatalogMainPage';
import Certificate from '@/pages/Certificate';
import ContactUs from '@/pages/ContactUs';
import Gallery from '@/pages/Gallery';
import ListGallery from '@/pages/Gallery/listGallery';
import Home from '@/pages/Home';
import Layout from '@/pages/layout';
import Product from '@/pages/Product';
import ListProduct from '@/pages/Product/listProduct';
import ListProductNew from '@/pages/Product/listProductNew';
import ProductDetail from '@/pages/Product/productDetail';
import { RouteObject } from 'react-router-dom';


export default [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: <Home />
      },
      {
        path: 'hakkimizda',
        element: <AboutUs />
      },

      {
        path: 'iletisim',
        element: <ContactUs />
      },
      {
        path: 'bloglar',
        element: <BlogPage />
      },
      {
        // path: pageGroup.find(x => x.page_name == "blog").sef_url + "/:id" //'/blog/:id',
        path: '/blog/:id',
        element: <BlogDetail />
      },
      {
        path: 'sertifikalar',
        element: <Certificate />
      },
      {
        path: '/haberler-duyurular',
        element: <AnnouncementNewsMainPage />
      },
      {
        path: '/haberler-duyurular/:category',
        element: <AnnouncementNews />,
      },
      {
        path: '/haberler-duyurular-detay/:id',
        element: <AnnouncementNewsDetail />
      },
      {
        path: 'katalog',
        element: <CatalogMainPage />
      },
      {
        path: '/katalog/:category',
        element: <Catalog />
      },
      {
        path: '/urunler',
        element: <Product />
      },
      {
        path: '/urunler/:id',
        element: <ListProductNew />
      },
      {
        path: '/urunler-liste/:index',
        element: <ListProduct />
      },
      {
        path: '/urun-detay/:id',
        element: <ProductDetail />
      },
      {
        path: '/galeri',
        element: <Gallery />
      },
      {
        path: '/galeri-liste/:category',
        element: <ListGallery />
      }

    ]
  }
] as RouteObject[];
